/**
 * Settings for i18n behavior.
 */
export class LocalizationSettings {
  /**
   * Indicates whether to use the appropriate pressure unit label or a custom one.
   */
  public shouldUseCustomPressureUnitLabel = false
}
